import React from 'react';

import { useSettings } from 'app/main/components';
import { type DetailsPageRightSidebarProps } from 'app/main/components/page-layouts';

import ProjectsDetailsSectionStatsGeneral from './sections/ProjectsDetailsSectionStatsGeneral';
import ProjectsDetailsSectionStatsWorkReports from './sections/ProjectsDetailsSectionStatsWorkReports';

export default function ProjectsDetailsRightSidebarSections(props: DetailsPageRightSidebarProps) {
	const { sysSettings } = useSettings();

	const canShowFinancialStats = sysSettings.projects_show_financial_stats === 'true';

	const stats = props.model.proj_stats;
	const workReportsStats = stats?.proj_workreports_stats;

	const sections: React.ReactNode[] = [];

	if (!props.isAdd) {
		if (stats && canShowFinancialStats) {
			sections.push(<ProjectsDetailsSectionStatsGeneral stats={stats} />);
		}
		if (workReportsStats) {
			sections.push(<ProjectsDetailsSectionStatsWorkReports stats={workReportsStats} />);
		}
	}

	return sections;
}
